
export enum DoorPreferenceTypeCd {
	LOAD_UNLOAD = 'LoadUnload',
	STEP_SAVER_EXCLUDE = 'StepSaverExclude',
	TRAP = 'Trap'}
